/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Parameters for event planning status check job.

Daily check to ensure event kinds have sufficient slot planning based on
EventKind configuration. No parameters needed as it evaluates all
event kinds for the tenant.
 */
export interface EventPlanningCheckParams {
  [key: string]: unknown;
}
